import React from "react";
import "./contactUs.css";
import ContactForm from "./ContactForm";

const ContactUs = () => {
  return (
    <div className="contact-page-wrapper">
      <ContactForm />
    </div>
  );
};

export default ContactUs;
